//src/components/ResetPassword.jsx

import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosInstance';
import { toast } from 'react-toastify';
import { Avatar, Button, TextField, Box, Typography, Paper, Grid, CssBaseline } from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';
import backgroundImage from '../assets/login.jpeg';


const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
      toast.error('Las contraseñas no coinciden');
      return;
    }
    
    setLoading(true);
    
    console.log('URL completa:', axiosInstance.defaults.baseURL + '/auth/custom-password-reset-confirm/');
    console.log('Datos enviados:', { uid, token, new_password: newPassword });
    
    try {
      const response = await axiosInstance.post('/auth/custom-password-reset-confirm/', {
        uid,
        token,
        new_password: newPassword
      });
      
      console.log('Respuesta:', response.data);
      toast.success('Contraseña restablecida correctamente');
      navigate('/login');
    } catch (err) {
      console.error('Error completo:', err);
      
      // Mostrar más detalles del error
      if (err.response) {
        console.error('Respuesta de error:', err.response.data);
        toast.error(`Error: ${err.response.data.error || 'El enlace podría haber expirado'}`);
      } else {
        toast.error('Error al restablecer la contraseña. El enlace podría haber expirado.');
      }
    } finally {
      setLoading(false);
    }
  }; // <-- Esta llave faltaba

  return (
    <Grid
      container
      component="main"
      sx={{
        height: '100vh',
        width: '100vw',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CssBaseline />
      <Grid
        item
        xs={11}
        sm={8}
        md={5}
        lg={4}
        component={Paper}
        elevation={6}
        sx={{ p: 4, borderRadius: 4, backgroundColor: 'rgba(255, 255, 255, 0.9)', backdropFilter: 'blur(4px)' }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockResetIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Restablecer Contraseña
          </Typography>
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Nueva Contraseña"
              name="newPassword"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Confirmar Nueva Contraseña"
              name="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <Button 
              type="submit" 
              fullWidth 
              variant="contained" 
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? 'Procesando...' : 'Restablecer Contraseña'}
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ResetPassword;
